import { useEffect, useState } from 'react';
import { Flex, Text, theme, Button } from '../../../2022-component-library';
import { useReceiveMessage, usePostMessage } from '../../../context/messageContext';
import { useCalibration } from '../../../context/calibrationContext';
import { keyframes } from '@emotion/react';

const ResponsiveCameraCalibrationOpticianContainer = ({ setActiveTab }) => {
  const [calibrationStatus, setCalibrationStatus] = useState(0);
  const { updateCalibrationData, calibrationData } = useCalibration();
  const messageFromPatient = useReceiveMessage();
  const postMessage = usePostMessage();

  const calibrateCamera = () => {
    setCalibrationStatus(1);
    updateCalibrationData({ cameraCalibrated: false });
    setTimeout(() => postMessage({ type: 'initialiseToolDetections', content: {} }), 2000);
  };

  useEffect(() => {
    if (messageFromPatient?.type === 'perceivedFocalLength') {
      let cameraCalibrated = true;
      if (!messageFromPatient.content.perceivedFocalLength) {
        setCalibrationStatus(0);
        cameraCalibrated = false;
      }
      updateCalibrationData({ perceivedFocalLength: messageFromPatient.content.perceivedFocalLength, cameraCalibrated: cameraCalibrated });
    }
  }, [messageFromPatient, updateCalibrationData]);

  useEffect(() => {
    if (calibrationData.cameraCalibrated) setCalibrationStatus(2);
  }, [calibrationData.cameraCalibrated]);

  return (
    <Flex column centered>
      <Flex column alignItems='center'>
        <Text marginBottom='2rem'>{`Please wait for the patient to position the tool, then click "Begin Calibration".`}</Text>
        <Button
          width='20em'
          disabled={calibrationStatus === 1}
          marginBottom='1rem'
          backgroundColor={calibrationStatus === 1 ? theme.colors.neutralLight : theme.colors.success}
          onClick={() => {
            calibrateCamera();
          }}
        >{`BEGIN CALIBRATION`}</Button>
        <CameraCalibrationStatusIndicator currentStatus={calibrationStatus} />
        <Button
          marginTop='1rem'
          disabled={calibrationStatus === 1}
          onClick={() => {
            setActiveTab('calibration-selection');
          }}
        >{`BACK`}</Button>
      </Flex>
    </Flex>
  );
};

const CameraCalibrationStatusIndicator = ({ currentStatus }) => {
  const statusMap = { 0: 'Not Calibrated', 1: 'Calibrating...', 2: 'Calibration Complete' };
  return (
    <Flex column centered width='350px' padding='1rem' boxShadow='0px 0px 6px rgba(0, 0, 0, 0.26)' borderRadius='12px'>
      <Flex width='100%' justifyContent='space-evenly' marginBottom='2rem'>
        <TrafficLight color='red' active={currentStatus === 0} />
        <TrafficLight color='amber' active={currentStatus === 1} />
        <TrafficLight color='green' active={currentStatus === 2} />
      </Flex>
      <Flex centered width='100%'>
        <Text fontWeight='bold' fontSize='0.825rem' width='55%' textAlign='right'>{`Calibration Status:\u00a0`}</Text>
        <Text width='45%' fontSize='0.825rem'>
          {statusMap[currentStatus]}
        </Text>
      </Flex>
    </Flex>
  );
};

const TrafficLight = ({ color, active }) => {
  const bgColors = { red: theme.colors.error, amber: theme.colors.warning, green: theme.colors.success };
  return (
    <Flex
      borderRadius='50%'
      height='40px'
      width='40px'
      backgroundColor={bgColors[color]}
      style={{ opacity: active ? 1 : 0.3 }}
      animation={color === 'amber' && active ? `${growFade} 1200ms infinite` : null}
    ></Flex>
  );
};

const growFade = keyframes`
0% {
  opacity: 1;
  transform: scale(0);
}

100% {
  opacity: 0;
  transform: scale(1.2);
}
`;

export default ResponsiveCameraCalibrationOpticianContainer;
